import {
  ADD_TO_CART,
  CLEAR_CART,
  REMOVE_FROM_CART,
  RESET_BILL,
  SET_BILL_ROWS,
  SET_BILL_TYPE,
  SET_CART_ITEMS_FROM_STORAGE,
  SET_CUSTOMER,
  SET_CUSTOMER_TYPE,
  SET_PAYMENT_METHOD,
  SET_TRANSPORT_DETAILS,
  SET_TRANSPORT_ENABLED,
  UPDATE_QUANTITY,
} from '../actionConstants';
import {saveCartToStorage} from '../localStorage/localCartStorage';

const initialState = {
  items: [],
  customer: {},
  paymentMethod: 'CASH',
  billType: 'GST',
  customerType: 'CUSTOMER',
  transportEnabled: false,
  transport: {},
  rows: [],
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {

    case ADD_TO_CART: {
      const updatedItems = [...state.items, action.payload];

      saveCartToStorage(updatedItems, 'guest');

      return {
        ...state,
        items: updatedItems,
      };
    }

    case REMOVE_FROM_CART: {
      const updatedItems = state.items.filter(
        item => item.productId !== action.payload.productId,
      );

      saveCartToStorage(updatedItems, 'guest');

      return {
        ...state,
        items: updatedItems,
      };
    }

    case UPDATE_QUANTITY: {
      const updatedItems = state.items.map(item =>
        item.productId === action.payload.productId
          ? {
            ...item,
            ...action.payload,   
          }
          : item,
      );
      saveCartToStorage(updatedItems, 'guest');
      return {...state, items: updatedItems};
    }

    case SET_CUSTOMER:
      return { 
        ...state,
        customer: action.payload,
      };

    case SET_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.payload,
      };

    case 'SET_PAYMENT_MODE':
      return {
        ...state,
        paymentMode: action.payload,
      };

    case SET_BILL_TYPE:
      return {
        ...state,
        billType: action.payload,
      };

    case SET_CUSTOMER_TYPE:
      return {
        ...state,
        customerType: action.payload,
      };

    case SET_TRANSPORT_ENABLED:
      return {
        ...state,
        transportEnabled: action.payload,
      };

    case SET_TRANSPORT_DETAILS:
      return {
        ...state,
        transport: action.payload,
      };

    case SET_BILL_ROWS:
      return {
        ...state,
        rows: action.payload,
      };

    case RESET_BILL:
      saveCartToStorage([], 'guest');
      return initialState;

    default:
      return state;
  }
};

export default cartReducer;
